<template>
  <div class="text-center h-full flex items-center justify-center">
    <div class="flex flex-col items-center">
      <h1 class="text-blue text-9xl font-bold">404!</h1>
      <p class="text-gray text-2xl font-light">page not found</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "404",
};
</script>

<style scoped>
</style>